<mat-toolbar class="header bgPrimaryWhite100">
  <ui-logo></ui-logo>
  <ui-main-menu class="header-menu"></ui-main-menu>

</mat-toolbar>
